import { render, staticRenderFns } from "./bank-dialog.vue?vue&type=template&id=63f787be&"
import script from "./bank-dialog.vue?vue&type=script&lang=js&"
export * from "./bank-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bank-dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports